import $ from "jquery";
import "what-input";

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require("foundation-sites");

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).foundation();

// スマホ用vhを用意
const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

let vh = window.innerHeight;
$(window).on("resize", () => {
  if (vh === window.innerHeight) {
    return;
  }
  setFillHeight();
  vh = window.innerHeight;
});

setFillHeight();

// 別ページからアンカーリンクへ飛ばす
if (
  window.location.href.split("#")[1] == undefined ||
  window.location.href.split("#")[1].indexOf("=") == -1
) {
  var $target = $("#" + window.location.href.split("#")[1]);
  if ($target.length) {
    $(window).on("load", function () {
      var targetPosition = $target.offset().top;
      $("html").add($("body")).animate({ scrollTop: targetPosition }, 10);
    });
  }
}
